import { Link } from "react-router-dom";
import ProductCard from "@/components/ProductCard";
import { ArrowRight } from "lucide-react";

export function RelatedProducts({ products, title = "Products we use" }) {
  if (!products?.length) return null;
  return (
    <section data-testid="related-products">
      <h2 className="font-heading font-bold text-xl text-steel mb-3">{title}</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">{products.map((p) => <ProductCard key={p.id} product={p} />)}</div>
    </section>
  );
}

export function LinkCards({ items, title, testid }) {
  if (!items?.length) return null;
  return (
    <section data-testid={testid}>
      <h2 className="font-heading font-bold text-xl text-steel mb-3">{title}</h2>
      <div className="grid sm:grid-cols-2 gap-3">
        {items.map((s) => (
          <Link key={s.path} to={s.path} className="group rounded-xl border bg-white p-4 hover:border-accent transition-colors">
            <div className="font-semibold text-steel flex items-center justify-between gap-2">{s.name}<ArrowRight size={16} className="text-accent group-hover:translate-x-1 transition-transform" /></div>
            {s.summary && <p className="text-sm text-slate-600 mt-1 line-clamp-2">{s.summary}</p>}
          </Link>))}
      </div>
    </section>
  );
}

export function ArticleCard({ a }) {
  return (
    <Link to={`/articles/${a.slug}`} className="group rounded-xl border bg-white overflow-hidden hover:border-accent transition-colors flex flex-col" data-testid={`article-card-${a.slug}`}>
      {a.image && <img src={a.image} alt={a.image_alt || a.title} className="w-full aspect-[16/9] object-cover" loading="lazy" />}
      <div className="p-4 flex-1">
        <h3 className="font-bold text-steel group-hover:text-accent leading-snug">{a.title}</h3>
        {a.excerpt && <p className="text-sm text-slate-600 mt-1 line-clamp-3">{a.excerpt}</p>}
      </div>
    </Link>
  );
}
